import { useState, useEffect, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface ExportField {
    code: string;
    label: string;
}

interface ApiExportField {
    querySegmentFieldsId: number;
    exportField: boolean;
    isExportField: boolean;
    label: string;
    name: string;
}

const normalizeExportField = (apiField: ApiExportField): ExportField | null => {
    if (!apiField.name || apiField.isExportField === false || apiField.exportField === false) return null;

    return { code: apiField.name, label: apiField.label || apiField.name };
};

export const useExportFields = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const [fields, setFields] = useState<ExportField[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchFields = useCallback(async () => {
        if (!isReady) return;

        setLoading(true);
        setError(null);
        try {
            const response = await authFetch('/getExportFields', { method: 'GET' });
            const apiFields: ApiExportField[] = Array.isArray(response) ? response : (response as any)?.data || [];
            const converted = apiFields
                .map(normalizeExportField)
                .filter((f): f is ExportField => f !== null);
            setFields(converted);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Erreur lors du chargement des champs exportables');
        } finally {
            setLoading(false);
        }
    }, [authFetch, isReady]);

    useEffect(() => {
        fetchFields();
    }, [fetchFields]);

    return { fields, loading, error, refetch: fetchFields };
};
